import React from 'react';
import { TextAreaStyles } from '../../assets/theme/TextAreaStyles';
import RFFTextField from './RFFTextField';

const NotesTypeField = (props) => <RFFTextField {...props} sx={{ ...TextAreaStyles() }} />;

export default NotesTypeField;
